import React from "react";
import * as PropTypes from "prop-types";
import { Link } from "react-router-dom";

import styles from "./AppHeader.module.css";
import logout from "./icon-logout.svg";
import logo from "./fees-logo-white.svg";
// import moreApps from "./icon-more-apps.svg";
import menu from "./icon-menu.svg";
import NotificationTray from "components/UI/NotificationTray";
import FeatureRenderer from "components/Feature/RendererContainer";
import IconChangePassword from "components/Icon/ChangePassword";
import IconChangeRole from "components/Icon/ChangeRole";
import {Helmet} from "react-helmet";

const AppHeader = ({ title, onTrayTrigger }) => {
  return (
    <header className={styles.header} data-app-header>
      <a href="#foo" className={styles.icon} data-nav-toggle>
        <img
          className={styles.hamburger}
          alt="Menu button"
          src={menu}
          onClick={onTrayTrigger}
        />
      </a>
      <div className={styles.logo}>
        <img alt="" src={logo} title={title}/>
      </div>
      <Helmet>
        <meta httpEquiv="Strict-Transport-Security" content="max-age=31536000; includeSubDomains; preload"/>
      </Helmet>

      <Link to="/change-password">
        <IconChangePassword className={styles.icon} />
      </Link>

      <FeatureRenderer feature="GhostingUser">
        <Link to="/change-role">
          <IconChangeRole className={styles.icon} />
        </Link>
      </FeatureRenderer>

      <FeatureRenderer feature="Notifications">
        <NotificationTray className={styles.icon} />
      </FeatureRenderer>

      <Link to="/logout" className={styles.icon}>
        <img alt="" src={logout} title="Logout" />
      </Link>  

      {/* <a href="#foo" className={styles.icon}>
        <img alt="" src={moreApps} />
      </a> */}
    </header>
  );
};

AppHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onTrayTrigger: PropTypes.func.isRequired
};

export default AppHeader;
